// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__a3RGw","card__body":"styles_card__body__NN4Pq"};